import { Container, Group, Stack, Text, Title } from '@mantine/core';

import { useRoleFlags } from '@/hooks/useRbac';
import { LocalhostOnlyBadge } from '@/components/LocalhostOnlyBadge';
import { isUnifyAdminShellRole } from '@/config/featureVisibility';
import { AiTreatmentPlanningSettings } from './AiTreatmentPlanningSettings';
import { TransferSummaryPromptSettings } from './TransferSummaryPromptSettings';

export function ClinicalSettingsPage(): JSX.Element {
  const { isAdmin, role } = useRoleFlags();
  const showLocalhostBadge = !isUnifyAdminShellRole(role);

  return (
    <Container size="lg" py="xl">
      <Stack gap="xl">
        <div>
          <Group gap="sm" align="center" wrap="wrap" mb="xs">
            <Title order={2} mb={0}>
              Clinical settings
            </Title>
            {showLocalhostBadge ? <LocalhostOnlyBadge /> : null}
          </Group>
          <Text size="sm" c="dimmed">
            Configure clinical workflows and AI documentation preferences
          </Text>
        </div>

        <TransferSummaryPromptSettings />
        {isAdmin ? <AiTreatmentPlanningSettings /> : null}
      </Stack>
    </Container>
  );
}
